import {ModalService, CorrespondantStore} from "@digicerba/common";
import {ArticleDto, ICommandeMaterielWebServiceClient} from "@resources/resources";
import {PanierStore} from "@common/store/panier.store";
import {ActivatedRoute, Router} from "@angular/router";
import {Component, Input} from "@angular/core";

@Component({
  selector: 'article-liste',
  templateUrl: './liste.article.component.html',
  host: { 'class': 'article-list' }
})
export class ArticleComponent {

  @Input() article: ArticleDto;
  selectedValue = null;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
              private panierStore: PanierStore,
              private commandeMaterielWebServiceClient: ICommandeMaterielWebServiceClient,
              private modalService: ModalService, private correspondantStore: CorrespondantStore) {
  }

  ngOnInit() {
    this.selectedValue = 0;
  }

  goToDetailPage() {
    this.router.navigate(['../../article', this.article.id], { relativeTo: this.activatedRoute });
  }

  ajoutPanier() {
    this.panierStore.addItem(this.article.id, this.selectedValue).subscribe(result => {
      this.openModal();
    });
  }

  isActive() {
    return this.article.quota > 0 && this.article.actif;
  }

  getArticleQuota() {
    if (!this.article.actif) {
      return 0;
    }
    return this.article.quota;
  }

  openModal() {
    let dialog = this.modalService.openConfirmDialog("MODAL.ADD_LIGNE_COMMANDE.title", "MODAL.ADD_LIGNE_COMMANDE.message",
      "MODAL.ADD_LIGNE_COMMANDE.confirm", "MODAL.ADD_LIGNE_COMMANDE.cancel");
    dialog.onDialogCancel().subscribe(() => {
      this.router.navigate(['cerba/panier']);
    });
    dialog.onDialogClose().subscribe(() => {
      var finalUrl = this.router.url;
      if (finalUrl.indexOf(";") > -1) {
        finalUrl = finalUrl.substring(0, this.router.url.indexOf(';'))
      }
      this.router.navigate([finalUrl, {update: new Date().getTime()}]);
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-articles/liste-article/liste.article.component.ts